// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  AssetScopeRole,
} from "./types";


export default __t.row({
  grantId: __t.u64().primaryKey().name("grant_id"),
  identity: __t.identity(),
  scope: __t.string(),
  get role() {
    return AssetScopeRole;
  },
  grantedAt: __t.timestamp().name("granted_at"),
});
